import React from 'react';
import StageWithText from 'commonComponents/Stages/StageWithText/StageWithText';
import FactsAndNumbers from './FactsAndNumbers/FactsAndNumbers';
import Overview from './Overview/Overview';
import Investment from './Investment/Investment';
import Consultants from 'commonComponents/Consultants/Consultants';
import Organizations from './Organizations/Organizations';
import News from './News/News';
import Exception from './Exception/Exception';
import styles from '../pages.module.scss';

/*eslint max-lines-per-function: ["error", 200]*/
const InvestmentLocations = ({
  banner, pageName, facts, overview, investment, consulting,
  work, universities, news, newsPhotos, exception,
  funnelLink
}) => {
  const classes = `${styles.Page} ${styles.InvestmentLocation}`;

  const { name, position } = consulting;
  const consultants = [
    { name: 'Michelle Steiger' },
    { name, position, isPrimary: true },
    { name: 'Matthias Stokowy' }
  ];

  return (
    <div className={ classes }>
      <StageWithText
        { ...banner }
        pageName={ pageName }        
      />
      <FactsAndNumbers { ...facts } />
      <Overview { ...overview } />
      <Investment { ...investment } link={ funnelLink } />
      <Consultants { ...consulting } consultants={ consultants }
        link={ funnelLink }
      />
      <Organizations { ...work } anchor='work' />
      <Organizations { ...universities } anchor='universities' />
      <News
        { ...news }
        newsPhotos={ newsPhotos }
      />
      <Exception { ...exception } />
    </div>
  );
};
 
export default InvestmentLocations;
